module.exports = __webpack_public_path__ + "static/christian-51b4002d7417b270d5d6fbed136aee31.jpg";